import { reactive } from 'vue'

export const store = reactive({
  username: '',
  userTitle: '',
  email: '',
  avatar: '',
  location: '',
  role: ''
})
